/**
 * 独立 fetch：不走业务 http-interceptor，不上报失败 toast。
 */

import {
  ANALYTICS_TRANSPORT_TIMEOUT_MS,
  getAnalyticsBaseURL,
  isAnalyticsEnabled
} from './config'
import type { AnalyticsEventPayload } from './types'

function isReportSuccess(data: unknown): boolean {
  if (data == null || typeof data !== 'object') return true
  const code = (data as { code?: unknown }).code
  if (code == null) return true
  return Number(code) === 200 || code === '200' || Number(code) === 0
}

async function postJson(path: string, body: unknown): Promise<boolean> {
  if (!isAnalyticsEnabled()) return false
  const baseURL = getAnalyticsBaseURL()
  if (!baseURL) return false

  const controller = typeof AbortController !== 'undefined' ? new AbortController() : null
  const timer =
    controller != null
      ? window.setTimeout(() => controller.abort(), ANALYTICS_TRANSPORT_TIMEOUT_MS)
      : 0

  try {
    const res = await fetch(`${baseURL}${path}`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=UTF-8',
        Authorization: 'Bearer anonymous'
      },
      body: JSON.stringify(body),
      signal: controller?.signal
    })
    if (!res.ok) return false
    const data = await res.json().catch(() => null)
    return isReportSuccess(data)
  } catch {
    return false
  } finally {
    if (timer) window.clearTimeout(timer)
  }
}

export async function postAnalyticsEvent(event: AnalyticsEventPayload): Promise<boolean> {
  return postJson('/event', event)
}

export async function postAnalyticsEvents(events: AnalyticsEventPayload[]): Promise<boolean> {
  if (events.length === 0) return true
  return postJson('/events', events)
}
